import { isBrowser } from "./environment.js";
export function calculateSettingsTimeout() {
    if (isBrowser()) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const nav = globalThis?.navigator;
        const connection = nav?.connection || nav?.mozConnection || nav?.webkitConnection;
        let timeout = 10_000;
        switch (connection?.effectiveType) {
            case 'slow 2g':
            case 'slow-2g':
                timeout = 60_000;
                break;
            case '2g':
                timeout = 30_000;
                break;
            case '3g':
                timeout = 15_000;
                break;
            case '4g':
                timeout = 5_000;
                break;
        }
        const unsafeIsMobile = nav?.userAgentData?.mobile ??
            (nav?.maxTouchPoints > 0 ||
                (globalThis?.document &&
                    'ontouchstart' in globalThis.document.documentElement));
        if (unsafeIsMobile) {
            timeout = Math.min(timeout * 2, 60_000);
        }
        return timeout;
    }
    return 6_000;
}
//# sourceMappingURL=settings-timeout.js.map